import {styled} from '@mui/material';

export const PageTitleContainer = styled('section')({
    gridArea: 'page-title'
});
